import { render } from "./form.vue?vue&type=template&id=ad0501b4"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad0501b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad0501b4', __exports__)) {
    console.log('reload')
    api.reload('ad0501b4', __exports__)
  }
  
  module.hot.accept("./form.vue?vue&type=template&id=ad0501b4", () => {
    console.log('re-render')
    api.rerender('ad0501b4', render)
  })

}


export default __exports__